export function watchOnce(vueInstance, propToWatch) {
    return new Promise((resolve) => {
        const unwatch = vueInstance.$watch(propToWatch, (value) => {
            unwatch();
            resolve(value);
        });
    });
}
